import { unstable_useId as useId } from '@material-ui/utils';
export default useId;